import SlimSelect from "slim-select";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["slackRecipientsWrapper", "slackRecipientsSelect", "emailFields"];

  connect() {
    console.log("Platforms controller connected");

    // Read preselected values from data attribute
    
    this.toggleEmailFields()
    // Check if Slack is already checked
    const slackCheckbox = this.element.querySelector(
        'input[type="checkbox"][value="Slack"]'
      );

    if (slackCheckbox && slackCheckbox.checked) {
      this.showSlackRecipients();
      const preselectedRaw = this.element.dataset.preselected || "[]";
      this.preselected = JSON.parse(preselectedRaw);
      console.log("Preselected recipients:", this.preselected);
      this.fetchSlackRecipients(this.preselected);
    }
  }

  toggleSlackRecipients(event) {
    this.toggleEmailFields()
    const checked = event.target.checked;
    const platform = event.target.value;

    if (platform === "Slack") {
      if (checked) {
        this.showSlackRecipients();
        this.fetchSlackRecipients(this.preselected);
      } else {
        this.hideSlackRecipients();
      }
    }
  }

  showSlackRecipients() {
    this.slackRecipientsWrapperTarget.style.display = "block";
  }

  hideSlackRecipients() {
    this.slackRecipientsWrapperTarget.style.display = "none";
  }

  fetchSlackRecipients(preselected = []) {
    fetch("/slack_recipients")
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          console.log(data.message)
          this.showErrorModal(data.message)
        } else {
          this.slackRecipientsSelectTarget.innerHTML = "";

          data.recipients.forEach(recipient => {
            const option = document.createElement("option");
            option.value = recipient.id;
            option.textContent = recipient.name;

            if (preselected.map(String).includes(String(recipient.id))) {
              option.selected = true;
            }

            this.slackRecipientsSelectTarget.appendChild(option);
          });

          if (this.slackSelectInstance) {
            this.slackSelectInstance.destroy();
          }

          this.slackSelectInstance = new SlimSelect({
            select: this.slackRecipientsSelectTarget,
            placeholder: "Select Slack recipients",
            closeOnSelect: false,
            showSearch: true
          });
        }
      })
      .catch(error => {
        console.error("Error fetching Slack recipients:", error);
      });
  }

  showErrorModal(message) {
    const modal = document.getElementById("errorModal");
    const errorMessage = document.getElementById("errorMessage");
    const closeBtn = document.querySelector(".close-btn-platforms");
    const noBtn = document.getElementById("modalNoBtn");

    // Set error text
    errorMessage.textContent = message;

    // Show modal
    modal.style.display = "flex";

    // Close modal on X or No
    const closeModal = () => {
      modal.style.display = "none"
      this.hideSlackRecipients()
    };
    closeBtn.onclick = closeModal;
    noBtn.onclick = closeModal;

    // Close modal when clicking outside
    window.onclick = function(event) {
      if (event.target === modal) {
        closeModal();
      }
    };
  }

  toggleEmailFields() {
    const emailChecked = [...this.platformCheckboxElements()].some(
      el => el.value === "Email" && el.checked
    )
    this.emailFieldsTarget.style.display = emailChecked ? "" : "none"
  }

  platformCheckboxElements() {
    return this.element.querySelectorAll("[data-platformsplatformcheckbox]")
  }
}
